<template>
  <JdsSidePanel @close="handleClose" :remove-horizontal-class="true">
    <template #body>
      <div v-if="review">
        <!-- This block is only for netmeds. Text position and Icon size are different only in this. -->
        <div
          v-if="currentVertical.netmeds"
          class="fe-p-m fe-bg-sparkle-20 fe-rounded-b-xl fe-mb-m"
        >
          <div class="sm:fe-hidden">
            <div class="fe-flex fe-items-center fe-justify-end">
              <JdsButton
                @click="handleClose"
                :icon-only="true"
                variant="tertiary"
              >
                <template #icon>
                  <JdsIcon
                    name="CloseIcon"
                    size="m"
                    color="fe-text-primary-60"
                  />
                </template>
              </JdsButton>
            </div>
          </div>
          <div class="fe-flex fe-items-center fe-pb-base">
            <div class="fe-flex fe-gap-xxs fe-items-center">
              <div class="fe-flex">
                <JdsIcon
                  name="SuccessIcon"
                  color="fe-text-success-50"
                  className="fe-w-xl fe-h-xl"
                />
              </div>

              <div class="fe-text-heading-xs">Thank you so much 🎉</div>
            </div>
          </div>
          <div class="fe-text-body-s fe-text-primary-grey-80">
            We are processing your review.
            {{
              !currentVertical.netmeds
                ? "This might take several days, so we appreciate your patience."
                : ""
            }}
            We will email you when this is complete.
          </div>
        </div>

        <!-- This block is for all other verticals -->
        <div v-else class="fe-p-m fe-bg-sparkle-20 fe-rounded-b-xl fe-mb-m">
          <div class="fe-flex fe-justify-between">
            <div class="fe-pt-base">
              <!-- We don't have 56px in JDS, but it is being used in figma, so using the width and height manually -->
              <JdsIcon
                name="SuccessIcon"
                color="fe-text-success-50"
                className="!fe-w-[56px] !fe-h-[56px]"
              />
            </div>

            <div class="sm:fe-hidden">
              <JdsButton
                @click="handleClose"
                :icon-only="true"
                variant="tertiary"
              >
                <template #icon>
                  <JdsIcon
                    name="CloseIcon"
                    size="m"
                    color="fe-text-primary-60"
                  />
                </template>
              </JdsButton>
            </div>
          </div>
          <div>
            <div class="fe-text-heading-xs fe-mb-s">Thank you so much 🎉</div>
            <div class="fe-text-body-s fe-text-primary-grey-80">
              We are processing your review. This might take several days, so we
              appreciate your patience. We will email you when this is complete.
            </div>
          </div>
        </div>

        <div class="fe-px-m">
          <div class="fe-flex fe-gap-xs fe-mb-base">
            <div>
              <LazyImage
                :src="review.productImage"
                alt="product image"
                class-name="fe-w-[84px] fe-h-[84px] fe-rounded-xl fe-border fe-border-solid fe-border-primary-grey-40 fe-cursor-default"
              />
            </div>
            <div>
              <div class="fe-text-body-xxs fe-text-primary-grey-80 fe-pb-xxs">
                {{ review.productBrand }}
              </div>
              <div class="fe-text-body-xxs-bold">{{ review.productName }}</div>
            </div>
          </div>

          <div>
            <div class="fe-text-heading-xxs">Your review</div>
            <div class="fe-mb-xs">
              <StarRating
                :read-only="true"
                :initial-rating="review.rating"
                size="s"
              />
            </div>
          </div>

          <div
            v-if="review.images?.length"
            class="fe-flex fe-items-center fe-w-full fe-overflow-x-auto fe-no-scrollbar fe-mb-xs"
          >
            <!-- Selected Image Thumbnails -->
            <div class="fe-flex fe-gap-xs">
              <LazyImage
                v-for="(image, index) in review.images"
                :key="image.fileName"
                :src="image.url"
                placeholder="none"
                :alt="'Uploaded Image ' + (index + 1)"
                class-name="
                fe-w-huge fe-h-huge fe-cursor-pointer fe-rounded-medium
              "
              />
            </div>
          </div>

          <div>
            <div class="fe-mb-xs fe-text-body-xs-bold">{{ review.title }}</div>
            <div
              class="fe-mb-xs fe-text-body-xxs fe-text-primary-grey-80 fe-overflow-hidden fe-line-clamp-3"
            >
              {{ review.content }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="fe-flex fe-justify-between fe-items-center">
        <JdsButton
          size="medium"
          variant="primary"
          :full-width="true"
          @click="handleClose"
        >
          Done
        </JdsButton>
      </div>
    </template>
  </JdsSidePanel>
</template>

<script>
  import JdsSidePanel from "@/components/DesignSystem/JdsSidePanel/JdsSidePanel.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import LazyImage from "@/components/DesignSystem/LazyImage/LazyImage.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import { checkCurrentVerticals } from "@/utils/utils"

  export default {
    name: "ThankYouPage",
    components: {
      JdsSidePanel,
      JdsButton,
      StarRating,
      LazyImage,
      JdsIcon,
    },
    props: {
      review: {
        type: [Object, null],
        default: null,
        required: true,
      },
    },
    computed: {
      currentVertical() {
        return checkCurrentVerticals()
      },
    },
    methods: {
      handleClose() {
        this.$emit("close")
      },
    },
  }
</script>
